import { Model } from '../../api';

export class WidgetModel extends Model {

    public name: string;

    public title: string;

    public component: any;

    public options: any = {};

    public constructor(data, service) {
        super(data, service);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/models/widget.model.ts